<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="렌탈" @rental="rental" :type="'order'" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="progress">
          <ol>
            <li><span>동의</span></li>
            <li><span>본인인증</span></li>
            <li class="on"><span>결제정보입력 및 확인</span></li>
            <li><span>계약서작성</span></li>
          </ol>
        </div>

        <section v-if="!joinSuccess" class="hr new_h">
          <div class="titArea">
            <h2 class="titH3">간편회원가입하고, 쿠폰할인 받으세요.</h2>
            <p class="desc">
              간편회원 가입 시,
              <br />
              적용 가능한 최대 할인쿠폰이 자동으로 적용돼요.
            </p>
          </div>

          <ul v-if="coupon" class="couponList mt20">
            <li>
              <a class="block bgColor0">
                <div class="inner">
                  <strong class="copy medium">{{ coupon.title }}</strong>
                  <span class="desc">렌탈전용 웰몰쿠폰</span>
                </div>
              </a>
            </li>
          </ul>

          <span class="singleIpt boxBtn cbIco_acco" :class="{ on: quickJoin }">
            <input type="checkbox" class="ipt" name="simple" id="simple" v-model="quickJoin" />
            <label for="simple">간편회원가입 하기</label>
          </span>

          <div v-show="quickJoin">
            <ValidationObserver ref="form">
              <div class="formArea">
                <span class="label">
                  아이디
                  <span class="required"><span class="blind">필수</span></span>
                </span>

                <ValidationProvider name="아이디" rules="required|userId" v-slot="{ errors }" vid="userId">
                  <div class="setAddr">
                    <input
                      type="text"
                      autocapitalize="off"
                      id="ipt1_1"
                      class="ipt"
                      placeholder="영문, 숫자 포함 4~12자리"
                      title="아이디 입력(영문, 숫자 포함 4~12자리(이메일도 가능))"
                      maxlength="12"
                      v-model="userId"
                      onfocus="this.scrollIntoView({block: 'center'})"
                    />
                    <button type="button" class="btn_g m" @click="idCheck">중복확인</button>
                  </div>
                  <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>

                <span class="label">
                  비밀번호
                  <span class="required"><span class="blind">필수</span></span>
                </span>
                <ValidationProvider name="비밀번호" rules="required|password" v-slot="{ errors }" vid="password">
                  <input
                    type="password"
                    id="ipt2"
                    class="ipt"
                    placeholder="영문 대/소문자, 숫자, 특수문자 포함 8자리 이상"
                    title="비밀번호 입력(영문 대/소문자, 숫자, 특수문자 포함 8자리 이상)"
                    value=""
                    v-model="password"
                  />
                  <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>

                <span class="label">
                  비밀번호 확인
                  <span class="required"><span class="blind">필수</span></span>
                </span>
                <ValidationProvider name="비밀번호 확인" rules="required|confirmed:password" v-slot="{ errors }" vid="passwordChk">
                  <input
                    type="password"
                    id="ipt3"
                    class="ipt"
                    placeholder="동일한 비밀번호를 입력해주세요"
                    title="비밀번호 확인 입력(동일한 비밀번호를 입력해주세요)"
                    value=""
                    v-model="passwordChk"
                  />
                  <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </div>
            </ValidationObserver>
            <!-- 약관 (s) -->
            <div class="termsWrap">
              <div class="block accoHead">
                <input type="checkbox" class="ipt" name="termsGroup1" id="terms1_all" v-model="chkAll" />
                <label for="terms1_all">전체동의</label>
              </div>

              <p class="txtXS pointC6 mb10">고객 편의 제공을 위하여 여러 동의사항에 대한 '전체 동의' 기능을 제공하고 있습니다.</p>

              <div class="accoBody">
                <ul class="iptGroup">
                  <li>
                    <div class="block">
                      <input type="checkbox" class="ipt" name="termsSub" id="terms1" value="0" v-model="chkSub" />
                      <label for="terms1">
                        웰몰 서비스 이용약관
                        <em>필수</em>
                        동의
                      </label>
                      <button type="button" class="links arrow" onClick="document.getElementById('terms1').click()">
                        <span class="blind">상세약관 전체보기</span>
                      </button>
                    </div>
                  </li>
                  <li>
                    <div class="block">
                      <input type="checkbox" class="ipt" name="termsSub" id="terms2" value="1" v-model="chkSub" />
                      <label for="terms2">
                        서비스 제공을 위한 개인정보 수집/이용
                        <em>필수</em>
                        동의
                      </label>
                      <button type="button" class="links arrow" onClick="document.getElementById('terms2').click()">
                        <span class="blind">상세약관 전체보기</span>
                      </button>
                    </div>
                  </li>
                  <li v-show="!showAgree">
                    <div class="block accoHead">
                      <input type="checkbox" class="ipt" name="termsGroup1" id="terms3" v-model="chkSub3All" />
                      <label for="terms3">
                        상품서비스 안내 등을 위한
                        <em>선택</em>
                        동의
                      </label>
                      <button type="button" class="btnIco_acco accoBtn">
                        <span>
                          <span class="blind">상세약관</span>
                          전체보기
                        </span>
                      </button>
                    </div>
                    <div class="accoBody">
                      <ul class="iptGroup">
                        <li>
                          <div class="block">
                            <input type="checkbox" class="ipt" name="termsGroup1" id="terms3_1" v-model="agreeCollection" />
                            <label for="terms3_1">
                              <span>[선택]</span>
                              개인(신용)정보 수집 및 이용 동의
                            </label>
                            <button type="button" class="links arrow" onClick="document.getElementById('terms3_1').click()">
                              <span class="blind">상세약관 전체보기</span>
                            </button>

                            <ul class="iptGroup div_3">
                              <li>
                                <input type="checkbox" class="ipt" name="chk0" id="chk0_1" v-model="agreeTel" />
                                <label for="chk0_1">전화</label>
                              </li>
                              <li>
                                <input type="checkbox" class="ipt" name="chk0" id="chk0_2" v-model="agreeSms" />
                                <label for="chk0_2">문자메세지</label>
                              </li>
                              <li>
                                <input type="checkbox" class="ipt" name="chk0" id="chk0_3" v-model="agreeDm" />
                                <label for="chk0_3">DM</label>
                              </li>
                              <li>
                                <input type="checkbox" class="ipt" name="chk0" id="chk0_4" v-model="agreeEmail" />
                                <label for="chk0_4">이메일</label>
                              </li>
                              <li>
                                <input type="checkbox" class="ipt" name="chk0" id="chk0_5" v-model="agreeAppPush" />
                                <label for="chk0_5">푸시</label>
                              </li>
                            </ul>
                          </div>
                        </li>
                        <!-- <li>
                          <div class="block">
                            <input type="checkbox" class="ipt" name="termsGroup1" id="terms3_2" v-model="agreeCredit" />
                            <label for="terms3_2">
                              <span>[선택]</span>
                              개인(신용)정보 제공 동의
                            </label>
                            <button type="button" class="links arrow" onClick="document.getElementById('terms3_2').click()">
                              <span class="blind">상세약관 전체보기</span>
                            </button>
                          </div>
                        </li> -->
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 약관 (e) -->
            <div id="joinButton" class="btnArea mt20">
              <button @click="guestJoinValidate" type="button" class="btn_h" :disabled="joinProcess">간편회원가입 완료</button>
            </div>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">결제 금액</h2>
          </div>

          <div class="totalSum bgNone">
            <div class="total">
              <strong class="tit">렌탈료</strong>
              <span class="money">
                월
                <em>{{ rentalAmount | currency }}</em>
                원
              </span>
            </div>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">결제정보 선택</h2>
          </div>
          <!-- tabWrap (s) -->
          <div class="tabWrap">
            <ul class="tabList iptBtn">
              <li class="on" @click="resetForm('RDUT00CC')">
                <span class="ico">카드결제</span>
              </li>
              <li @click="resetForm('RDUT00CM')">
                <span class="ico">CMS자동이체</span>
              </li>
            </ul>
            <div class="tabContents">
              <div class="tabPanel">
                <div class="formArea">
                  <span class="label">카드선택</span>
                  <select class="ipt" title="카드선택" v-model="payInfo.cardName">
                    <option value="" selected="selected">선택해주세요</option>
                    <option v-for="(option, key) in cardList" v-bind:value="option.code" v-bind:key="key">
                      {{ option.codeName }}
                    </option>
                  </select>
                  <p class="txtList_remark">본인 결제수단만 진행 가능</p>

                  <span class="label">카드번호</span>
                  <div class="transkey">
                    <div class="setCard">
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="4"
                        title="카드번호 첫번째 4자리"
                        id="cardNum1"
                        v-model="cardNum1"
                        nextTarget="cardNum2"
                        v-onlyNum
                        v-skipOfMax
                        value=""
                        onfocus="this.scrollIntoView({block: 'center'})"
                        @focus="focus = true"
                        @blur="focus = false"
                      />

                      <span class="sign" aria-hidden="true">-</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="4"
                        v-model="cardNum2"
                        id="cardNum2"
                        nextTarget="cardNum3"
                        v-skipOfMax
                        title="카드번호 두번째 4자리"
                        v-onlyNum
                        value=""
                        onfocus="this.scrollIntoView({block: 'center'})"
                        @focus="focus = true"
                        @blur="focus = false"
                      />
                      <span class="sign" aria-hidden="true">-</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="4"
                        id="cardNum3"
                        nextTarget="cardNum4"
                        title="카드번호 세번째 4자리"
                        v-skipOfMax
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView({block: 'center'})"
                      />
                      <span class="sign" aria-hidden="true">-</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="4"
                        id="cardNum4"
                        title="카드번호 마지막 4자리"
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                    </div>
                  </div>

                  <span class="label">유효기간</span>
                  <div class="transkey">
                    <div class="setPeriod">
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="2"
                        id="expirdateMM"
                        nextTarget="expirdateYY"
                        title="유효기간 월 2자리"
                        placeholder="MM"
                        v-skipOfMax
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                      <span class="sign" aria-hidden="true">/</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="2"
                        id="expirdateYY"
                        title="유효기간 년 2자리"
                        placeholder="YY"
                        v-skipOfMax
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                    </div>
                  </div>

                  <span class="label">결제일</span>
                  <select class="ipt" title="결제일 선택" v-model="payInfo.dueDate">
                    <option value="" selected="selected">선택해주세요</option>
                    <option v-for="(option, key) in dueDateList" v-bind:value="option.code" v-bind:key="key">
                      {{ option.codeName }}
                    </option>
                  </select>

                  <!-- <span class="singleIpt">
                  <span class="singleIpt">
                  <span class="singleIpt" v-show="false">

                    <input type="checkbox" class="ipt" name="chk" id="chk1" />
                    <label for="chk1">입력한 결제 정보를 다음에도 사용</label>
                  </span> -->
                </div>
              </div>
              <div class="tabPanel">
                <div class="formArea">
                  <span class="label">은행선택</span>
                  <select class="ipt" title="은행선택" v-model="payInfo.bankCode">
                    <option value="" selected="selected">선택해주세요</option>
                    <option v-for="(option, key) in bankList" v-bind:value="option.code" v-bind:key="key">
                      {{ option.codeName }}
                    </option>
                  </select>
                  <p class="txtList_remark">본인 결제수단만 진행 가능</p>

                  <span class="label">계좌번호</span>
                  <input type="tel" class="ipt" title="계좌번호 입력" v-model="payInfo.bankAccnt" v-onlyNum v-show="!useSecureKeyPad" />
                  <div class="transkey">
                    <input
                      type="tel"
                      class="ipt"
                      id="accountNum"
                      maxlength="16"
                      title="계좌번호 입력"
                      placeholder="- 없이 입력해주세요"
                      value=""
                      data-tk-kbdType="number"
                      onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      v-show="useSecureKeyPad"
                    />
                  </div>
                  <span class="singleIpt mt10 ar">
                    <input type="checkbox" class="ipt" name="chk" id="chk2" v-model="useSecureKeyPad" />
                    <label for="chk2">보안키패드로 입력</label>
                  </span>

                  <span class="label">이체일</span>
                  <select class="ipt" title="이체일 선택" v-model="dueDate">
                    <option value="" selected="selected">선택해주세요</option>
                    <option v-for="(option, key) in dueDateList" v-bind:value="option.code" v-bind:key="key">
                      {{ option.codeName }}
                    </option>
                  </select>

                  <span class="label">현금영수증</span>
                  <ul class="iptGroup iptBtn">
                    <li>
                      <input
                        type="radio"
                        class="ipt"
                        name="rdo2"
                        id="rdo2_1"
                        v-model="payInfo.cashReqYn"
                        v-bind:value="cashTypeCode[0]"
                        checked="checked"
                      />
                      <label for="rdo2_1"><span class="ico">발행</span></label>
                    </li>
                    <li>
                      <input type="radio" class="ipt" name="rdo2" id="rdo2_2" v-model="payInfo.cashReqYn" v-bind:value="cashTypeCode[1]" />
                      <label for="rdo2_2"><span class="ico">미발행</span></label>
                    </li>
                  </ul>

                  <div v-show="payInfo.cashReqYn == 'Y'">
                    <span class="label">휴대폰번호</span>
                    <input type="tel" class="ipt" title="휴대폰번호 입력" v-model="payInfo.cashNum" v-onlyNum value="" />
                  </div>

                  <!-- <span class="singleIpt">
                    <input type="checkbox" class="ipt" name="chk" id="chk3" />
                    <label for="chk3">입력한 결제 정보를 다음에도 사용</label>
                  </span> -->
                </div>
              </div>
            </div>
          </div>
          <!-- tabWrap (e) -->

          <div class="btnArea" :class="{ sticky: !focus }">
            <button type="button" class="btn_p" @click="validate">다음</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
    <ConfirmPop @cancel="cancel" @confirm="confirm" v-if="confirmPop" @close="close">
      <p v-html="msg"></p>
      <template v-if="guestSelect" v-slot:btnArea>동의안함</template>
      <template v-if="guestSelect" v-slot:btnArea2>동의함</template>
    </ConfirmPop>
    <WebViewPop v-if="webViewPop" :pageName="pageName" @close="webviewClose" :type="webViewType">
      <div v-html="webView"></div>
      <template v-slot:closeButton>
        <button type="button" class="btnIco_close" @click="disagreement">
          <span>팝업 닫기</span>
        </button>
      </template>
    </WebViewPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import MessagePop from '@/components/popup/MessagePop';
import { isEmpty, calcAge, checkBackPeop } from '@/common/common.function';
import { INPUT_INFO_CHECK, TERM_AGREE_CHECK, GO_HOME, JOIN_AGE_CHECK } from '@/store/message.type';
import ConfirmPop from '@/components/popup/ConfirmPop';
import $ from 'jquery';
import WebViewPop from '@/components/popup/WebViewPop';
export default {
  name: 'guestStep3',
  components: {
    MessagePop,
    ConfirmPop,
    WebViewPop,
  },
  mounted() {
    //console.log($(document).height() - $(window).height());
    console.log(this.$route.params.request);
    $('.btnGoTop').remove();
    this.request = this.$route.params.request;
    this.coupon = this.request.coupon;

    // 적용가능한 쿠폰 조회 회원/비회원
    this.showAgree = this.request.chkSub3All;
    this.agreeCollection = this.request.selectAgreeInfo.agreeCollection == 'SLAG0001' ? true : false;
    this.agreeAppPush = this.request.selectAgreeInfo.agreeAppPush == 'SLAG0001' ? true : false;
    this.agreeCredit = this.request.selectAgreeInfo.agreeCredit == 'SLAG0001' ? true : false;
    this.agreeDm = this.request.selectAgreeInfo.agreeDm == 'SLAG0001' ? true : false;
    this.agreeEmail = this.request.selectAgreeInfo.agreeEmail == 'SLAG0001' ? true : false;
    this.agreeSms = this.request.selectAgreeInfo.agreeSms == 'SLAG0001' ? true : false;
    this.agreeTel = this.request.selectAgreeInfo.agreeTel == 'SLAG0001' ? true : false;
    // this.showAgree = true;
    // this.agreeCollection = true;
    // this.agreeAppPush = true;
    // this.agreeCredit = true;
    // this.agreeDm = true;
    // this.agreeEmail = true;
    // this.agreeSms = true;
    // this.agreeTel = true;

    ApiService.service('GET', '/product/' + this.request.orderCommInfo.productCode, {
      params: '',
    })
      .then(({ data }) => {
        this.product = data.result;
        for (let i = 0; i < data.result.prodOptionCollect.length; i++) {
          if (data.result.prodOptionCollect[i].prodCode == this.request.orderCommInfo.internalProdCode) {
            this.rentalAmount = data.result.prodOptionCollect[i].rentalAmount;
          }
        }

        this.prodInfo = data.result.product;
        this.prodColor = data.result.productColors;
        this.prodDetail = data.result.productDetail;
        this.prodOption = data.result.productOption;
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
        this.prodInfo = [];
        this.prodColor = [];
        this.prodDetail = [];
        this.prodOption = [];
      });
    ApiService.service('GET', '/common/code/RCAD,RDUE,RBAK', {
      params: '',
    })
      .then(({ data }) => {
        for (let item of data.result) {
          if (item.codePrefix == 'RCAD') {
            this.cardList = item.codeList;
          } else if (item.codePrefix == 'RDUE') {
            this.dueDateList = item.codeList;
          } else if (item.codePrefix == 'RBAK') {
            this.bankList = item.codeList;
          }
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    // 회원가입 필수, 선택동의 웹뷰 url 리스트
    ApiService.service('GET', 'common/webView/WB000009', {
      params: '',
    })
      .then(({ data }) => {
        this.webViews = data.result;
        for (let url of this.webViews) {
          this.allUrl.push(url.filePath);
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    // 보안키패드
    if (process.env.NODE_ENV != 'dev') {
      import('@/raon/welcomeTranskey').then((m) => {
        m.importCSS();
        m.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'accountNum']);
      });
    }

    //window.importCSS();
    //window.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'accountNum']); // 보안키패드
  },
  data() {
    return {
      chkSubNum: '-1',
      chkSubCnt: 0,
      chkAll: false, // 전체동의
      chkSub: [], // 필수, 선택 동의 여부
      agrAct0: true, // 전체동의
      agrAct1: true, // 1번 약관동의 액션 세이프키
      agrAct2: true, // 2번 약관동의 액션 휴대폰
      agrAct3: true, // 3번 약관동의 액션 상품서비스
      chkSub2All: false,
      chkSub3All: false,
      chkSub4All: false,
      agreeAppPush: false,
      agreeCollection: false,
      agreeDm: false,
      agreeEmail: false,
      agreeSms: false,
      agreeTel: false,
      agreeCredit: false,

      webViewPop: false, // 웹뷰 팝업
      webViewUrl: '', // 웹뷰 URL
      webView: '',
      webViews: [], // 웹뷰 리스트
      webViewType: 'agree',
      pageName: null, // 웹뷰 타이틀
      allUrl: [],

      rentalAmount: null, //렌탈 가격
      userId: '',
      password: '',
      passwordChk: '',
      msg: '',
      messagePop: false,
      confirmPop: false,
      quickJoin: false,
      idCheckYn: false, //아이디 체크 여부
      prodInfo: [],
      prodColor: [],
      prodDetail: [],
      prodOption: [],
      cardList: [],
      dueDateList: [],
      bankList: [],
      dueDate: '',
      cardNum1: null,
      cardNum2: null,
      cardNum3: null,
      cardNum4: null,
      bankPassword: '',
      expirdateYY: null,
      expirdateMM: null,
      cashTypeCode: ['Y', 'N'],
      payInfo: {
        checkType: 'RDUT00CC',
        cardName: '',
        cardNumber: '',
        cardExpireDate: '',
        dueDate: '',
        bankCode: '',
        bankAccnt: '',
        cashReqYn: 'N',
        cashNum: '', //현금영수증
        secureKeyPad: 'N', //보안키패드
        rmanCd: '', //추천코드
        couponCd: '',

        encCardNumber3: {},
        encCardNumber4: {},
        encCardExpireMM: {},
        encCardExpireYY: {},
        cardNumber1: '',
        cardNumber2: '',
        encAccountNumber: {},
      },
      request: null,
      // 보안키패드
      useSecureKeyPad: false,
      mtk: null,
      focus: false,
      joinSuccess: false,
      joinProcess: false,
      showAgree: false,
      coupon: null,
      guestSelect: false,
      scroll: false,
    };
  },
  watch: {
    quickJoin() {
      if (this.quickJoin) {
        const data = checkBackPeop(this.request.conOrderInfo.backSsn);
        // 만 14세 미만 체크
        if (calcAge(this.request.conOrderInfo.ssn.toString()) < 14) {
          this.joinSuccess = true;
          this.quickJoin = false;
          this.msg = JOIN_AGE_CHECK;
          this.messagePop = true;
        }

        if (this.request.joinInfo.joinYn == 'Y') {
          this.joinSuccess = true;
          this.request.joinInfo.joinYn = 'Y';
          //this.request.joinInfo.userId = ;
          console.log(this.request.coupon);
          console.log(this.request.coupon != null);
          if (this.request.coupon != null) {
            this.msg = `고객님은 웰몰에 가입한 이력이 확인되어,<br/>보유하신 최대 할인쿠폰이 적용됩니다.`;
          } else {
            this.msg = `고객님은 이미 웰몰에 가입하였습니다.<br/>이어서 렌탈을 진행해주세요.`;
          }
          this.messagePop = true;
        }
      }
    },
    chkSub() {
      //console.log(this.chkSub);
      if (this.chkSub.length - this.chkSubCnt == 1) {
        this.openPop(this.chkSub[this.chkSub.length - 1]);
        const chk1 = this.chkSub.includes('0');
        const chk2 = this.chkSub.includes('1');
        if (!this.chkAll && chk1 && chk2 && this.chkSub3All) {
          console.log('chksub1');
          this.agrAct0 = false;
          this.chkAll = true;
        }
      } else if (this.chkSub.length - this.chkSubCnt == -1) {
        const chk1 = this.chkSub.includes('0');
        const chk2 = this.chkSub.includes('1');
        if (this.chkAll && (!chk1 || !chk2)) {
          console.log('chksub2');
          this.agrAct0 = false;
          this.chkAll = false;
        }
      }
      this.chkSubCnt = this.chkSub.length;
    },
    chkAll() {
      //전체 선택은 체크 하되 하위액션은 X
      console.log(this.chkAll + ':chkAll:' + this.agrAct0);
      if (this.agrAct0 == false) {
        this.agrAct0 = true;
        return false;
      }
      //약관 초기화
      this.chkSub = [];

      this.agrAct2 = true;
      this.agrAct3 = true;
      // this.agreeAppPush = false;
      // this.agreeCollection = false;
      // this.agreeDm = false;
      // this.agreeEmail = false;
      // this.agreeSms = false;
      // this.agreeTel = false;
      // this.agreeCredit = false;

      if (this.chkAll) {
        console.log('open');
        this.openPop(-1);

        this.chkSub2All = true;
        this.chkSub3All = true;

        const array_termsSub = document.getElementsByName('termsSub');
        for (let i = 0; i < array_termsSub.length; i++) {
          this.chkSub.push(array_termsSub[i].value);
        }

        this.agreeAppPush = true;
        this.agreeCollection = true;
        this.agreeDm = true;
        this.agreeEmail = true;
        this.agreeSms = true;
        this.agreeTel = true;
        this.agreeCredit = true;
      } else {
        this.chkSub = [];
        this.agrAct2 = false;
        this.chkSub2All = false;
        if (!this.showAgree) {
          this.agrAct3 = false;
          this.agreeAppPush = false;
          this.agreeCollection = false;
          this.agreeDm = false;
          this.agreeEmail = false;
          this.agreeSms = false;
          this.agreeTel = false;
          this.agreeCredit = false;
        }
      }
    },
    chkSub3All() {
      const chk1 = this.chkSub.includes('0');
      const chk2 = this.chkSub.includes('1');
      if (this.chkSub3All) {
        if (!this.chkAll && chk1 && chk2 && this.chkSub3All) {
          //전체 체크 안되고  // 1번 2번 체크 //휴대폰 전체 체크 // 선택 체크시 <<전체동의 변경
          console.log('chksub3all1');
          this.agrAct0 = false;
          this.chkAll = true;
        }
      } else {
        if (chk1 && chk2 && this.chkAll) {
          console.log('chksub3all2');
          this.agrAct0 = false;
        }
        this.chkAll = false;
      }

      if (this.agrAct3 == false) {
        this.agrAct3 = true;
        return false;
      }

      if (this.chkSub3All && this.agreeCollection && this.agreeCredit) {
        console.log('true');
      } else if (this.chkSub3All) {
        this.openPop(-4);

        this.agreeAppPush = true;
        this.agreeCollection = true;
        this.agreeCredit = true;
        this.agreeDm = true;
        this.agreeEmail = true;
        this.agreeSms = true;
        this.agreeTel = true;
      } else {
        this.agreeAppPush = false;
        this.agreeCollection = false;
        this.agreeCredit = false;
        this.agreeDm = false;
        this.agreeEmail = false;
        this.agreeSms = false;
        this.agreeTel = false;
      }
    },
    agreeCollection() {
      console.log(this.agreeCollection && (this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel));

      if (this.agreeCollection && (this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
        if (this.agreeCredit && !this.chkSub3All) {
          this.agrAct3 = false;
          this.chkSub3All = true;
        }
      } else if (this.agreeCollection) {
        this.openPop(2);
        this.agreeAppPush = true;
        this.agreeCollection = true;
        this.agreeDm = true;
        this.agreeEmail = true;
        this.agreeSms = true;
        this.agreeTel = true;
      } else {
        this.agreeAppPush = false;
        this.agreeCollection = false;
        this.agreeDm = false;
        this.agreeEmail = false;
        this.agreeSms = false;
        this.agreeTel = false;

        if (this.chkSub3All) {
          this.agrAct3 = false;
          this.chkSub3All = false;
        }
      }
    },
    // agreeCredit() {
    //   if (!this.agreeCredit && this.chkSub3All) {
    //     this.agrAct3 = false;
    //     this.chkSub3All = false;
    //   }
    //   if (this.agreeCredit && !this.chkAll && !this.chkSub3All) {
    //     this.openPop(3);
    //   }
    // },
    agreeAppPush() {
      if (this.agreeAppPush) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeDm() {
      if (this.agreeDm) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeEmail() {
      if (this.agreeEmail) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeSms() {
      if (this.agreeSms) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeTel() {
      if (this.agreeTel) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
  },

  methods: {
    nextStep() {
      this.payInfo.encCardNumber3 = this.makeData('cardNum3', 'Y');
      this.payInfo.encCardNumber4 = this.makeData('cardNum4', 'Y');
      this.payInfo.encCardExpireMM = this.makeData('expirdateMM', 'Y');
      this.payInfo.encCardExpireYY = this.makeData('expirdateYY', 'Y');
      this.payInfo.cardNumber1 = this.cardNum1;
      this.payInfo.cardNumber2 = this.cardNum2;
      this.payInfo.encAccountNumber = this.makeData('accountNum', 'Y');
      this.payInfo.secureKeyPad = this.useSecureKeyPad ? 'Y' : 'N';

      if (process.env.NODE_ENV != 'dev') {
        if (this.payInfo.checkType == 'RDUT00CC') {
          if (this.payInfo.cardName == '') {
            this.msg = '카드를 선택해주세요.';
            this.messagePop = true;
            return false;
          }
          if (
            isEmpty(this.cardNum1) ||
            isEmpty(this.cardNum2) ||
            isEmpty(this.payInfo.encCardNumber3.inputValue) ||
            isEmpty(this.payInfo.encCardNumber4.inputValue)
          ) {
            this.msg = '카드번호를 입력해주세요.';
            this.messagePop = true;
            return false;
          }
          if (isEmpty(this.payInfo.encCardExpireMM.inputValue) || isEmpty(this.payInfo.encCardExpireYY.inputValue)) {
            this.msg = '유효기간을 입력해주세요.';
            this.messagePop = true;
            return false;
          }
          if (this.payInfo.dueDate == '') {
            this.msg = '결제일를 선택해주세요.';
            this.messagePop = true;
            return false;
          }
        } else {
          if (this.payInfo.bankCode == '') {
            this.msg = '은행을 선택해주세요.';
            this.messagePop = true;
            return false;
          }
          if (this.payInfo.bankAccnt == '' && !this.useSecureKeyPad) {
            this.msg = '계좌번호를 압력해주세요.';
            this.messagePop = true;
            return false;
          }
          if (isEmpty(this.payInfo.encAccountNumber.inputValue) && this.useSecureKeyPad) {
            this.msg = '계좌번호를 입력해주세요.';
            this.messagePop = true;
            return false;
          }
          if (this.payInfo.bankAccnt.substring(0, 3) == '010' && this.payInfo.bankAccnt.length < 12) {
            this.msg = `평생계좌는 사용할 수 없습니다.<br>다른 계좌번호를 입력해주세요.`;
            this.messagePop = true;
            return false;
          }
          if (this.dueDate == '') {
            this.msg = '이체일을 선택해주세요.';
            this.messagePop = true;
            return false;
          }
          this.payInfo.dueDate = this.dueDate;
          if (this.payInfo.cashReqYn == 'Y') {
            if (this.payInfo.cashNum == '') {
              this.msg = '현금영수증 발급받으실 휴대폰번호를 선택해주세요.';
              this.messagePop = true;
              return false;
            }
          }
        }
      } else {
        if (this.payInfo.checkType == 'RDUT00CC') {
          let cardNumber = this.cardNum1 + this.cardNum2 + document.getElementById('cardNum3').value + document.getElementById('cardNum4').value;
          let cardExpireDate = document.getElementById('expirdateMM').value + document.getElementById('expirdateYY').value;

          this.payInfo.cardExpireDate = cardExpireDate;
          this.payInfo.cardNumber = cardNumber;

          this.payInfo.secureKeyPad = 'N';
          this.payInfo.cardNumber1 = this.cardNum1;
          this.payInfo.cardNumber2 = this.cardNum2;

          this.payInfo.encCardNumber3 = this.encCardNumber3;
          this.payInfo.encCardNumber4 = this.encCardNumber4;
          this.payInfo.encCardExpireMM = this.encCardExpiredMM;
          this.payInfo.encCardExpireYY = this.encCardExpiredYY;
        } else {
          this.payInfo.dueDate = this.dueDate;
          this.payInfo.secureKeyPad = 'N';
          this.payInfo.encAccountNumber = this.encAccountNumber;
        }
      }

      this.request.payInfo = this.payInfo;
      this.$refs.header.loadingStart(); // 로딩끝
      ApiService.service('POST', 'order/rental', {
        request: this.request,
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed && data.result.resultCode != 1) {
            if (this.quickJoin) {
              const params = {
                af_registration_method: '비회원간편',
                af_used_rental: data.result.rentalUsedYn,
              };
              //const appsFlyerParams = JSON.stringify(params);
              window.appsFlyer('af_complete_registration', params);
            }

            const params = {
              af_method: '비회원',
              af_revenue: this.prodDetail.saleAmount,
              af_price: this.rentalAmount,
              af_content: this.prodDetail.rentalPeriodNm,
              af_content_id: this.request.orderCommInfo.productCode,
              af_order_id: this.request.orderCommInfo.orderId,
              af_content_type: '렌탈',
              af_used_rental: data.result.rentalUsedYn,
            };

            this.$router.push({
              name: 'guestStep4',
              params: { request: this.request, params: params },
            });
          } else {
            console.log(data);
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch((response) => {
          console.log(response);
        })
        .finally(() => {
          this.$refs.header.loadingEnd(); // 로딩끝
        });
    },
    validate() {
      let vue = this;
      if (this.quickJoin) {
        if (this.joinSuccess) {
          this.nextStep();
        } else {
          this.scroll = true;
          this.$refs.form.validate().then(async (success) => {
            if (!success) {
              this.msg = `회원가입 필수정보를 입력 하신 후<br/>간편회원가입을 완료해 주세요.`;
              this.messagePop = true;
            } else {
              if (!document.getElementById('terms1').checked || !document.getElementById('terms2').checked) {
                this.msg = `회원가입 필수동의를 하신 후<br/>간편회원가입을 완료해 주세요.`;
                this.messagePop = true;
                return false;
              }
              this.msg = `간편회원가입을 먼저 완료해 주세요.`;
              this.messagePop = true;
            }
          });
          window.scrollTo({ top: 200, behavior: 'smooth' });
          return false;
        }
      } else {
        if (!this.joinSuccess) {
          vue.request.joinInfo.joinYn = 'N';
          vue.request.coupon = null;
        }
        //this.payCheck();
        this.nextStep();
      }
    },
    idCheck() {
      if (isEmpty(this.userId)) {
        this.msg = '아이디를 입력해주세요.';
        this.messagePop = true;
        return false;
      }
      /* // 이 부분 API에서 진행
        let regex = /(?=.*[a-z])([a-z0-9]){4,12}/g;
        console.log(regex.test(this.userId));
        if (regex.test(this.userId)) {
          this.msg = '영문,숫자 포함 4~12자리로 입력해야 합니다.';
          this.messagePop = true;
          return false;
        } */
      ApiService.service('GET', 'user/idCheck/' + this.userId, {})
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.idCheckYn = true;
            this.msg = data.result;
            this.messagePop = true;
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    payCheck() {
      //결제 정보 확인
      let param;
      let apiUrl = '/pay/card/key';
      if (this.payInfo.checkType == 'RDUT00CC') {
        if (this.payInfo.cardName == '') {
          this.msg = '카드를 선택해주세요.';
          this.messagePop = true;
          return false;
        }
        if (isEmpty(this.cardNum1) || isEmpty(this.cardNum2) || isEmpty(this.cardNum3) || isEmpty(this.cardNum4)) {
          this.msg = '카드번호를 입력해주세요.';
          this.messagePop = true;
          return false;
        }
        if (isEmpty(this.expirdateYY) || isEmpty(this.expirdateMM)) {
          this.msg = '유효기간을 입력해주세요.';
          this.messagePop = true;
          return false;
        }
        if (this.payInfo.dueDate == '') {
          this.msg = '결제일를 선택해주세요.';
          this.messagePop = true;
          return false;
        }

        param = {
          request: {
            buyerName: this.request.conOrderInfo.customerName,
            cardExpireMM: this.expirdateMM,
            cardExpireYY: this.expirdateYY,
            cardNumber: this.payInfo.cardNumber,
            registNo: this.request.conOrderInfo.ssn,
          },
          serviceType: 'app',
        };
      } else {
        if (this.payInfo.bankCode == '') {
          this.msg = '은행을 선택해주세요.';
          this.messagePop = true;
          return false;
        }
        if (this.payInfo.bankAccnt == '' && !this.useSecureKeyPad) {
          this.msg = '계좌번호를 입력해주세요.';
          this.messagePop = true;
          return false;
        }
        if (this.payInfo.bankAccnt == '' && this.useSecureKeyPad) {
          this.msg = '계좌번호를 압력해주세요.';
          this.messagePop = true;
          return false;
        }

        if (this.payInfo.bankAccnt.substring(0, 3) == '010' && this.payInfo.bankAccnt.length < 12) {
          this.msg = `평생계좌는 사용할 수 없습니다.<br>다른 계좌번호를 입력해주세요.`;
          this.messagePop = true;
          return false;
        }

        if (this.payInfo.cashReqYn == 'Y') {
          if (this.payInfo.cashNum == '') {
            this.msg = '현급영수증 발급받으실 휴대폰번호를 선택해주세요.';
            this.messagePop = true;
            return false;
          }
        }
        apiUrl = '/pay/bankAccnt/check';
        param = {
          request: {
            customerName: this.request.conOrderInfo.customerName,
            bankAccnt: this.payInfo.bankAccnt,
            bankCode: this.payInfo.bankCode,
          },
          serviceType: 'web/app',
        };
      }
      ApiService.service('POST', apiUrl, param)
        .then(({ data }) => {
          console.log(data);
          if ((data.result.resultCode == '00' || data.result.resultCode == '0000') && data.isSucceed) {
            this.nextStep();
          } else {
            this.msg = data.result.resultMsg;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    resetForm(type) {
      console.log(type);
      this.payInfo.checkType = type;

      this.dueDate = '';
      this.cardNum1 = '';
      this.cardNum2 = '';
      this.cardNum3 = '';
      this.cardNum4 = '';
      this.expirdateYY = '';
      this.expirdateMM = '';

      this.payInfo.cardName = '';
      this.payInfo.cardNumber = '';
      this.payInfo.cardExpireDate = '';
      this.payInfo.dueDate = '';
      this.payInfo.bankCode = '';
      this.payInfo.bankAccnt = '';
      this.payInfo.cashReqYn = 'N';
      this.payInfo.cashNum = '';
    },
    makeData(id, encrytedYN, plainValue) {
      if (process.env.NODE_ENV == 'dev') return null;
      // eslint-disable-next-line no-undef
      let values = mtk.inputFillEncData(document.getElementById(id));
      let name = document.getElementById(id).name;
      let hidden = values.hidden;
      let hmac = values.hmac;

      // eslint-disable-next-line no-undef
      let keyboardType = transkey[id].keyboard;
      // eslint-disable-next-line no-undef
      let keyIndex = transkey[id].keyIndex;
      // eslint-disable-next-line no-undef
      let fieldType = transkey[id].fieldType;
      // eslint-disable-next-line no-undef
      let inputObjValue = transkey[id].inputObj.value;
      let seedKey = document.getElementById('seedKey').value;
      let initTime = document.getElementById('initTime').value;
      let ExE2E = values.ExE2E;

      let newRaonRequest = {};
      newRaonRequest.id = id;
      newRaonRequest.name = name;
      newRaonRequest.keyboardType = keyboardType;
      newRaonRequest.keyIndex = keyIndex;
      newRaonRequest.fieldType = fieldType;
      newRaonRequest.seedKey = seedKey;
      newRaonRequest.initTime = initTime;
      newRaonRequest.transkey = hidden;
      newRaonRequest.transkey_HM = hmac.toString();
      newRaonRequest.transkey_EXE2E = ExE2E;
      newRaonRequest.plainValue = plainValue;
      newRaonRequest.encrytedYN = encrytedYN;
      newRaonRequest.inputValue = inputObjValue;
      return newRaonRequest;
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
      this.bottomPop = false;
      this.noticePop = false;
      this.webViewPop = false;
      this.sharePop = false;
      this.findAddr = false;
      this.guestSelect = false;
    },
    rental() {
      this.msg = GO_HOME;
      this.confirmPop = true;
    },
    cancel() {
      // 취소 선택시 팝업 닫기
      if (this.guestSelect) {
        this.guestJoin();
      }
      this.confirmPop = false;
    },
    confirm() {
      if (this.guestSelect) {
        this.agreeCollection = true;
        this.agreeAppPush = true;
        this.agreeCredit = true;
        this.agreeDm = true;
        this.agreeEmail = true;
        this.agreeSms = true;
        this.agreeTel = true;
        this.confirmPop = false;
        this.guestJoin();
      } else {
        this.$router.replace('/');
      }
    },
    webviewClose() {
      console.log(this.chkSubNum);
      if (this.chkSubNum > -1) {
        if (!this.chkSub2All && this.chkSub.includes('3') && this.chkSub.includes('4') && this.chkSub.includes('5') && this.chkSub.includes('6')) {
          this.agrAct2 = false;
          this.chkSub2All = true;
        }
        if (!this.chkSub3All && this.agreeCredit && this.agreeCollection) {
          this.agrAct3 = false;
          this.chkSub3All = true;
        }
      }
      this.webViewPop = false;
    },

    disagreement() {
      let num = this.chkSubNum.toString();
      console.log(num);
      if (num == -1) {
        this.agrAct0 = true;
        this.chkAll = false;
      } else if (num == -3) {
        this.chkSub2All = false;
      } else if (num == -4) {
        this.chkSub3All = false;
      } else if (num == '2') {
        this.agreeCollection = false;
      } else if (num == '3') {
        this.agreeCredit = false;
      } else {
        for (let i = 0; i < this.chkSub.length; i++) {
          if (num == this.chkSub[i].toString()) {
            this.chkSub.splice(i, 1);
          }
        }
      }

      console.log(this.chkSub);
      this.webViewPop = false;
    },
    async openPop(num) {
      //this.pageName = pageName;
      if (this.webViewPop) return false;
      this.webViewPop = true;

      console.log(num);
      this.chkSubNum = num;
      if (num < 0) {
        if (num == -1) {
          this.pageName = '전체 약관';
        } else if (num == -3) {
          this.pageName = '휴대폰 본인인증 서비스 약관';
        } else if (num == -4) {
          this.pageName = '상품서비스 안내등을 위한 약관';
        }
        let html = '';

        for (let i = 0; i < this.allUrl.length; i++) {
          if (num == -3 && i < 3) {
            continue;
          }
          if (num == -4 && i < 2) {
            continue;
          }

          let res = await ApiService.service('GET', this.allUrl[i]);
          html += res.data;
        }

        this.webView = html;
      } else {
        this.webViewUrl = this.webViews[num].filePath;
        this.pageName = this.webViews[num].pageName;

        let res = await ApiService.service('GET', this.webViewUrl);

        this.webView = res.data;
        this.webViewPop = true;
      }
    },
    guestJoinValidate() {
      if (!this.agreeCollection) {
        this.guestSelect = true;
        this.msg = `특별한 혜택과 서비스의 기회를 놓치실 건가요?<br/>선택정보 수집 동의하고 혜택안내 받아보세요.`;
        this.confirmPop = true;
      } else {
        this.guestJoin();
      }
    },
    guestJoin() {
      const data = checkBackPeop(this.request.conOrderInfo.backSsn);
      // 만 14세 미만 체크
      if (calcAge(this.request.conOrderInfo.ssn.toString()) < 14) {
        // data._yyyy +
        this.msg = JOIN_AGE_CHECK;
        this.messagePop = true;
        return;
      }

      if (!document.getElementById('terms1').checked || !document.getElementById('terms2').checked) {
        this.msg = TERM_AGREE_CHECK;
        this.messagePop = true;
        return false;
      }

      this.$refs.form.validate().then(async (success) => {
        if (!success) {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
          return false;
        } else {
          if (!this.idCheckYn) {
            this.msg = '아이디 중복체크를 해주세요.';
            this.messagePop = true;
            return false;
          }
          this.request.joinInfo.joinYn = 'Y';
          this.request.joinInfo.userId = this.userId;
          this.request.joinInfo.password = this.password;
          this.request.joinInfo.selectedAgree3 = this.agreeCollection ? 'SLAG0001' : 'SLAG0002';

          this.request.selectAgreeInfo.agreeCollection = this.agreeCollection ? 'SLAG0001' : 'SLAG0002';
          this.request.selectAgreeInfo.agreeAppPush = this.agreeAppPush ? 'SLAG0001' : 'SLAG0002';
          this.request.selectAgreeInfo.agreeDm = this.agreeDm ? 'SLAG0001' : 'SLAG0002';
          this.request.selectAgreeInfo.agreeEmail = this.agreeEmail ? 'SLAG0001' : 'SLAG0002';
          this.request.selectAgreeInfo.agreeSms = this.agreeSms ? 'SLAG0001' : 'SLAG0002';
          this.request.selectAgreeInfo.agreeTel = this.agreeTel ? 'SLAG0001' : 'SLAG0002';
          this.request.selectAgreeInfo.agreeCredit = this.agreeCredit ? 'SLAG0001' : 'SLAG0002';

          this.joinProcess = true;
          this.$refs.header.loadingStart();
          ApiService.service('POST', 'user/guestJoin', {
            request: this.request,
            serviceType: 'app',
          })
            .then(({ data }) => {
              console.log(data);
              if (data.isSucceed) {
                // 자동 로그인 호출
                ApiService.service('POST', 'user/login', {
                  request: {
                    password: this.password,
                    userId: this.userId,
                  },
                  serviceType: 'app',
                })
                  .then(({ data }) => {
                    if (data.isSucceed) {
                      this.token = data.result.token;
                      JwtService.saveToken(this.token);
                      JwtService.setUserInfo(data.result.userInfoDto);
                    }
                  })
                  .catch(({ response }) => {
                    console.log(response);
                  });

                if (data.result.joinYn == 'Y') {
                  if (this.request.coupon.length > 0) {
                    this.msg = `고객님은 웰몰에 가입한 이력이 확인되어,<br/>보유하신 최대 할인쿠폰이 적용됩니다.`;
                  } else {
                    this.msg = `고객님은 이미 웰몰에 가입하였습니다.<br/>이어서 렌탈을 진행해주세요.`;
                  }
                } else {
                  this.msg = `간편회원가입이 완료되었습니다.`;
                }
                this.messagePop = true;
                this.joinSuccess = true;
                this.$refs.header.pushUpdate(this.agreeAppPush, this.userId);
                if (this.scroll) {
                  const location = $(document).height() - $(window).height();
                  window.scrollTo({ top: location, behavior: 'smooth' });
                }
              } else {
                this.request.joinInfo.joinYn = 'N';
                this.msg = data.error;
                this.messagePop = true;
              }
            })
            .catch(({ response }) => {
              console.log(response);
              this.request.joinInfo.joinYn = 'N';
            })
            .finally(() => {
              this.joinProcess = false;
              this.$refs.header.loadingEnd();
            });
        }
      });

      console.log(this.request);
    },
  },
};
</script>
